/* eslint-disable @typescript-eslint/no-explicit-any */

export default function Snackbar(): any {
  return { MuiSnackbarContent: { styleOverrides: { root: {} } } };
}
